(function () {
  function closeItem(details, wrap) {
    const startHeight = wrap.scrollHeight;
    wrap.style.maxHeight = startHeight + 'px';
    requestAnimationFrame(() => {
      wrap.style.maxHeight = '0px';
    });
    wrap.addEventListener(
      'transitionend',
      () => {
        details.removeAttribute('open');
        wrap.style.maxHeight = '';
      },
      { once: true }
    );
  }

  function openItem(details, wrap) {
    details.setAttribute('open', '');
    wrap.style.maxHeight = '0px';
    const targetHeight = wrap.scrollHeight;
    requestAnimationFrame(() => {
      wrap.style.maxHeight = targetHeight + 'px';
    });
    wrap.addEventListener(
      'transitionend',
      () => {
        wrap.style.maxHeight = 'none';
      },
      { once: true }
    );
  }

  document.querySelectorAll('.faq-section__list').forEach((list) => {
    const items = Array.from(list.querySelectorAll('.faq-item'));

    items.forEach((details) => {
      const summary = details.querySelector('summary');
      const wrap = details.querySelector('.faq-item__answer-wrap');
      if (!summary || !wrap) return;

      // Filen kan indlæses flere gange på samme side — FAQ-sektionen og et trin med
      // varianter tager begge deres eget script-tag med. Uden denne markering fik hvert
      // punkt to klik-handlere: den første åbnede, den anden lukkede med det samme, og
      // panelet så tomt ud.
      if (details.dataset.accordionBound) return;
      details.dataset.accordionBound = 'true';

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (details.open) {
          closeItem(details, wrap);
          return;
        }

        items.forEach((other) => {
          if (other !== details && other.open) {
            const otherWrap = other.querySelector('.faq-item__answer-wrap');
            if (otherWrap) closeItem(other, otherWrap);
          }
        });

        openItem(details, wrap);
      });
    });
  });
})();
